import React, { FC } from 'react';

import type { AirdropClaimRecordType } from '@api/index';
import car from '@images/airdrop/car.webp';
import rocket from '@images/airdrop/rocket.webp';
import rose from '@images/airdrop/rose.webp';
import toilet from '@images/airdrop/toilet.webp';

import { CarouselAuto } from '../../components/CarouselAuto';
import { HeaderInfo } from '../../components/HeaderInfo';
import { SendCard } from '../../send/SendCard';

import styles from './index.module.less';

interface AirdropMeBannerProps {
  historyData: AirdropClaimRecordType;
}

export const AirdropMeBanner: FC<AirdropMeBannerProps> = (props) => {
  const { historyData } = props;
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <HeaderInfo amount={historyData?.amount} />
      </div>
      <div className={styles.swiper}>
        <CarouselAuto width={623} height={442}>
          <SendCard width={129} height={192} src={rocket} />
          <SendCard width={158} height={210} src={toilet} />
          <SendCard width={91} height={199} src={rose} />
          <SendCard width={248} height={122} src={car} />
        </CarouselAuto>
      </div>
    </div>
  );
};
